export const isActive = (path: string) => {
    const pathname = window.location.pathname.split('/');
    return pathname[1] === path || pathname[2] === path;
};
